import { render } from "./ChooseDaycareStudent.vue?vue&type=template&id=dc81df8a"
import script from "./ChooseDaycareStudent.vue?vue&type=script&lang=js"
export * from "./ChooseDaycareStudent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__